// DO NOT EDIT MANUALLY
// This file was automatically generated by `scripts/MapboxStyles/process.ts`

import { MapboxStyleLayer } from '../types'

export const mapboxStyleGroupLayers_tilda_areas: MapboxStyleLayer[] = [
  {
    id: 'background colour',
    type: 'fill',
    paint: {
      'fill-color': [
        'case',
        ['match', ['get', 'parking'], ['multi-storey'], true, false],
        'rgb(233, 91, 84)',
        ['match', ['get', 'parking'], ['underground'], true, false],
        'rgb(142, 192, 169)',
        ['match', ['get', 'parking'], ['carports', 'carport'], true, false],
        'rgb(251, 206, 74)',
        ['match', ['get', 'building'], ['garages', 'garage', 'carport'], true, false],
        'rgb(251, 206, 74)',
        'rgb(48, 159, 219)',
      ],
    },
  },
  {
    id: 'stripe pattern',
    type: 'fill',
    filter: ['match', ['get', 'amenity'], ['bicycle_parking'], false, true],
    paint: {
      'fill-color': 'rgba(0, 0, 0, 0)',
      'fill-pattern': ['match', ['get', 'access'], ['customers', 'private'], 'stripe_texture', ''],
      'fill-opacity': 0.5,
    },
  },
]
